import { jsx as e, jsxs as M, Fragment as _ } from "react/jsx-runtime";
import * as p from "@radix-ui/react-tooltip";
import { useControllableState as w } from "@radix-ui/react-use-controllable-state";
import { OverrideAppearance as B } from "@telegraph/appearance";
import { RefToTgphRef as q } from "@telegraph/helpers";
import { Stack as H } from "@telegraph/layout";
import { motion as J } from "@telegraph/motion";
import { Text as K } from "@telegraph/typography";
import a from "react";
const L = {
  light: {
    border: "px",
    shadow: "2"
  },
  dark: {}
}, O = a.createContext({
  groupOpen: !1,
  setGroupOpen: () => {
  }
}), Q = ({ open: r, delay: o = 600 }) => {
  const t = a.useContext(O);
  return a.useEffect(() => {
    let i = null;
    return t.setGroupOpen && (r === !0 && t.setGroupOpen(!0), r === !1 && (i = setTimeout(() => {
      t.setGroupOpen && t.setGroupOpen(!1);
    }, o))), () => {
      i && clearTimeout(i);
    };
  }, [r, t, o]), {
    groupOpen: t.groupOpen
  };
}, rt = ({ children: r }) => {
  const [o, t] = a.useState(!1);
  return /* @__PURE__ */ e(O.Provider, { value: { groupOpen: o, setGroupOpen: t }, children: r });
}, ot = ({
  // Radix Tooltip Provider Props
  delayDuration: r = 400,
  skipDelayDuration: o,
  disableHoverableContent: t,
  // Radix Tooltip Root Props
  defaultOpen: i,
  open: g,
  onOpenChange: h,
  // Radix Tooltip Content Props
  "aria-label": T,
  onEscapeKeyDown: x,
  onPointerDownOutside: y,
  forceMount: C,
  side: u = "bottom",
  sideOffset: A = 4,
  align: v = "center",
  alignOffset: G,
  avoidCollisions: I,
  collisionBoundary: F,
  collisionPadding: N,
  arrowPadding: S,
  sticky: b,
  hideWhenDetached: E,
  // Label Props
  label: s,
  labelProps: c,
  // Telegraph Props
  enabled: P = !0,
  appearance: f = "dark",
  children: l
}) => {
  const [d, R] = w({
    prop: g,
    onChange: h,
    defaultProp: i
  }), { groupOpen: m } = Q({ open: !!d, delay: r }), j = a.Children.toArray(l).some(
    (n) => n.props.disabled
  ), k = m || j ? 0 : r, z = !m, D = (n) => {
    if (n === "top")
      return {
        y: -5
      };
    if (n === "bottom")
      return {
        y: 5
      };
    if (n === "left")
      return {
        x: -5
      };
    if (n === "right")
      return {
        x: 5
      };
  };
  return P ? /* @__PURE__ */ e(
    p.Provider,
    {
      delayDuration: k,
      skipDelayDuration: o,
      disableHoverableContent: t,
      children: /* @__PURE__ */ M(p.Root, { open: d, onOpenChange: R, children: [
        /* @__PURE__ */ e(p.Trigger, { asChild: !0, children: /* @__PURE__ */ e(q, { children: l }) }),
        /* @__PURE__ */ e(p.Portal, { children: /* @__PURE__ */ e(
          p.Content,
          {
            "aria-label": T,
            onEscapeKeyDown: x,
            onPointerDownOutside: y,
            forceMount: C,
            side: u,
            sideOffset: A,
            align: v,
            alignOffset: G,
            avoidCollisions: I,
            collisionBoundary: F,
            collisionPadding: N,
            arrowPadding: S,
            sticky: b,
            hideWhenDetached: E,
            style: {
              zIndex: "var(--tgph-zIndex-tooltip)"
            },
            children: /* @__PURE__ */ e(B, { appearance: f, asChild: !0, children: /* @__PURE__ */ e(
              H,
              {
                as: J.div,
                className: "tgph",
                initial: z ? {
                  opacity: 0,
                  scale: 0.5,
                  ...D(u)
                } : {},
                animate: {
                  opacity: 1,
                  scale: 1,
                  x: 0,
                  y: 0
                },
                transition: {
                  duration: 100,
                  type: "spring"
                },
                bg: "gray-1",
                rounded: "3",
                py: "2",
                px: "3",
                align: "center",
                justify: "center",
                style: {
                  transformOrigin: "var(--radix-tooltip-content-transform-origin)"
                },
                ...c ? { labelProps: c } : {},
                ...L[f],
                children: typeof s == "string" ? /* @__PURE__ */ e(K, { as: "span", size: "1", children: s }) : s
              }
            ) })
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ e(_, { children: l });
};
export {
  ot as Tooltip,
  rt as TooltipGroupProvider
};
//# sourceMappingURL=index.mjs.map
